import React from "react";
import "./style.scss";

const Courses = (props) => {
  return (
    <div className="courses p-4">
      <h2 className="text-center">Start with IoT and blockchain</h2>
      <div className="my-4">
        <h5 className="font-lg font-bold">
          <u>Course Title </u> :{" "}
          <span className="font-lg">
            Fundamentals of Internet of Things and Blockchain and Their
            Applications in Smart Grid
          </span>
        </h5>
      </div>

      <div className="mt-4">
        <h5 className="font-lg">
          <u>What to Learn in This Course ? : </u>
        </h5>
        <ul>
          <li>The fundamentals of the Internet of Things .</li>
          <li>The Fundamentals of blockchain .</li>
          <li>The applications of IoT (Internet of Things) in daily life .</li>
          <li>
            Understanding IoT architecture, design, Protocols, and components .
          </li>
          <li>Programming Framework for IoT .</li>
          <li>Smart meter simple design .</li>
          <li>
            Blockchain and IoT Applications Areas in Renewable Energy and Smart
            Grid .
          </li>
        </ul>
      </div>

      <div className="mt-4">
        <h5 className="font-lg">
          <u>Language : </u>
        </h5>
        <p>English (Intermediate level)</p>
      </div>

      <div className="mt-4">
        <h5 className="font-lg">
          <u>Who this course is designed for :</u>
        </h5>
        <ul>
          <li>
            Electrical engineering students and researchers in the smart grid
            field .
          </li>
          <li>Computer Engineers .</li>
          <li>Data Science students .</li>
        </ul>
      </div>

      <div className="mt-4">
        <h5 className="font-lg">
          <u>Requirements :</u>
        </h5>
        <ul>
          <li>Basics of programming skills .</li>
        </ul>
      </div>

      <div className="mt-4">
        <h5 className="font-lg">
          <u>Course Description :</u>
        </h5>
        <p>
          This course is designed to guide those interested in IoT and
          blockchain technology, especially in electrical engineering and smart
          electricity networks. The course is divided into seven chapters,
          beginning with the fundamentals and applications of IoT in everyday
          life and going through several IoT-based and Blockchain-based
          architectures, characteristics, and protocols. Further, several
          terminologies related to IoT and blockchain are discussed within this
          course, with explanations and examples. Furthermore, the smart grid
          concept is also covered in this course, and the role of blockchain and
          the internet of things is identified, including communication
          protocols for the IoT-based smart grid, smart contracts, peer-to-peer
          energy trading, and the role of various market participants in
          blockchain business model. Moreover, a simple smart meter design
          procedure is discussed within this course by providing design steps,
          equipment, and different requirements needed for the course
          participants to build their smart meter from scratch.
        </p>
      </div>

      <div className="mt-4">
        <h5 className="font-lg">
          <u>Course Content :</u>
        </h5>
        <ul>
          <p className="m-0">
            {" "}
            <b>IoT in Smart Grid</b>{" "}
          </p>
          <li>
            <a
              href={
                "https://drive.google.com/file/d/1an8OCOWAJDcDqCacnRYfTnKYnBuHYIMw/view?usp=sharing"
              }
              rel="noreferrer"
              target="_blank"
            >
              Lecture 1:{" "}
            </a>
            Fundamentals, Terminologies, and Applications .{" "}
          </li>
          <li>
            <a
              href={
                "https://drive.google.com/file/d/1tmp79M1gk9FGmUzQR2Kcit1pNjbQ3PY5/view?usp=sharing"
              }
              rel="noreferrer"
              target="_blank"
            >
              Lecture 2:{" "}
            </a>
            IoT Architectures and Protocols .
          </li>
          <li>
            <a
              href={
                "https://drive.google.com/file/d/1gR5yAW4gf9tbEtNBY1dbbY1ZjUpoYM0x/view?usp=sharing"
              }
              rel="noreferrer"
              target="_blank"
            >
              Lecture 3:{" "}
            </a>
            Programming Framework for IoT.
          </li>
          <li>
            <a
              href={
                "https://drive.google.com/file/d/1jA5gbR7obtSRDevFZMF7eWEkc0byJPj8/view?usp=sharing"
              }
              rel="noreferrer"
              target="_blank"
            >
              Lecture 4:{" "}
            </a>
            IoT Applications Areas in Renewable Energy.
          </li>
          <li>
            <a
              href={
                "https://drive.google.com/file/d/131meche_xmoKoxz6eUnkWKGzs9XnEO6m/view?usp=sharing"
              }
              rel="noreferrer"
              target="_blank"
            >
              Lecture 5:{" "}
            </a>
            IoT for Smart Grid.
          </li>
          <li>
            <a
              href={
                "https://drive.google.com/file/d/1kquFwi04XvaBJZouJXe5w1RQp9tEmO7y/view?usp=sharing"
              }
              rel="noreferrer"
              target="_blank"
            >
              Lecture 6:{" "}
            </a>
            Smart meter simple design.
          </li>
          <p className="mt-4 mb-1">
            {" "}
            <b> Blockchain in Smart grid</b>{" "}
          </p>

          <li>
            <a
              href={
                "https://drive.google.com/file/d/1mKpWFa4AjbnyWv9ZoemVCn74rLjmSsjN/view?usp=sharing"
              }
              rel="noreferrer"
              target="_blank"
            >
              Lecture 7:{" "}
            </a>
            Fundamentals of Blockchain Technology.
          </li>

          <li>
            <a
              href={
                "https://drive.google.com/file/d/1-FGwAZZzTdO0aNxyWdUF2ha5_2fPiMwy/view?usp=sharing"
              }
              rel="noreferrer"
              target="_blank"
            >
              Lecture 8:{" "}
            </a>
            Blockchain-Based Smart Grid.
          </li>
        </ul>
      </div>

      <div className="mt-4">
        <h5 className="font-lg">
          <u>Quizes </u>
        </h5>
        <ul>
          <li>
            <a
              href={
                "https://drive.google.com/file/d/16g2xQNe-ry3UHncWjduERaxNrp50OyAU/view?usp=sharing"
              }
              rel="noreferrer"
              target="_blank"
            >
              Quiz 1
            </a>
          </li>
          <li>
            <a
              href={
                "https://drive.google.com/file/d/1zT9PgqyzPoR7AeocqKmqIlfn3bd0rKFL/view?usp=sharing"
              }
              rel="noreferrer"
              target="_blank"
            >
              Quiz 2
            </a>
          </li>
          <li>
            <a
              href={
                "https://drive.google.com/file/d/1UlaWrcBq-g6wArEq1TR1FCmHnlq6QwQ8/view?usp=sharing"
              }
              rel="noreferrer"
              target="_blank"
            >
              Quiz 3
            </a>
          </li>
        </ul>
      </div>

      <div className="mt-4">
        <h5 className="font-lg">
          <u>Answers </u>
        </h5>
        <ul>
          <li>
            <a
              href={
                "https://drive.google.com/file/d/1wizq6dRYal38QBNiOWa2g-OR_uL-xDsO/view?usp=sharing"
              }
              rel="noreferrer"
              target="_blank"
            >
              Quiz 1
            </a>
          </li>
          <li>
            <a
              href={
                "https://drive.google.com/file/d/1yGLB3tdo_F8-xltOfN_-rq1z2BmoLwzX/view?usp=sharing"
              }
              rel="noreferrer"
              target="_blank"
            >
              Quiz 2
            </a>
          </li>
          <li>
            <a
              href={
                "https://drive.google.com/file/d/1A95gmQS-wypPaRIKD_UXKADHe9OZZIw2/view?usp=sharing"
              }
              rel="noreferrer"
              target="_blank"
            >
              Quiz 3
            </a>
          </li>
        </ul>
      </div>

      <div className="mt-4 references">
        <h5 className="font-lg">
          <u>References </u>
        </h5>
        <ul>
          <li>
            Shaw, R. N., Mendis, N., Mekhilef, S., & Ghosh, A. (Eds.). (2021).
            AI and IOT in Renewable Energy. Springer Singapore.
          </li>
          <li>
            Lakhwani, K., Gianey, H. K., Wireko, J. K., & Hiran, K. K. (2020).
            Internet of Things (IoT): Principles, paradigms and applications of
            IoT. Bpb Publications.
          </li>
          <li>
            Siozios, K., Anagnostos, D., Soudris, D., & Kosmatopoulos, E.
            (2019). IoT for smart grids (pp. 1-282). Cham, Switzerland:
            Springer.
          </li>
          <li>
            Alhasnawi, B. N., & Jasim, B. H. (2020). Internet of Things (IoT)
            for smart grids: a comprehensive review. J. Xi’an Univ. Archit, 63,
            1006-7930.
          </li>
          <li>
            Julie, E. G., Nayahi, J. J. V., & Jhanjhi, N. Z. (Eds.). (2020).
            Blockchain Technology: Fundamentals, Applications, and Case Studies.
            CRC Press.
          </li>
          <li>
            Shafie-khah, M. (Ed.). (2020). Blockchain-based Smart Grids.
            Academic Press.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Courses;
